import { cn } from "@/lib/utils";

type MonogramSize = "sm" | "md" | "lg";

const sizeToClass: Record<MonogramSize, string> = {
  sm: "text-lg sm:text-xl",
  md: "text-xl sm:text-2xl",
  lg: "text-2xl sm:text-3xl",
};

type MonogramProps = {
  size?: MonogramSize;
  as?: keyof React.JSX.IntrinsicElements;
  className?: string;
};

export function Monogram({
  size = "md",
  as: Component = "span",
  className,
}: MonogramProps) {
  return (
    <Component
      className={cn(
        "font-serif font-normal not-italic whitespace-nowrap",
        sizeToClass[size],
        className,
      )}
      style={{ letterSpacing: "-0.005em", lineHeight: 1 }}
    >
      SPR
    </Component>
  );
}
